import { Navigate } from 'react-router-dom';

import { useAppSelector } from '../redux-store/hooks';
import { RootState } from '../redux-store/store';
import { Status } from '../utils/notaryStatus';

const PublicRoute = ({ children = {} }) => {
  const registrationId = window.localStorage.getItem('registrationId');
  const status = window.localStorage.getItem('CommissionStatus');
  const isLoggedIn = useAppSelector(
    (state: RootState) => state.auth.isLoggedIn
  );
  const currentUser = useAppSelector(
    (state: RootState) => state.auth.currentUser
  );
  const isStatusPending = () => {
    return status === Status.Pending.toString();
  };

  const redirectUrl = () => {
    if (currentUser?.['custom:redirect_url']) {
      const uri = new URL(currentUser?.['custom:redirect_url']);
      if (uri.host.includes('docutech')) {
        window.location.href = uri.href;
        return '';
      } else {
        return uri.pathname;
      }
    } else {
      return '/orders';
    }
  };

  return (
    <>
      {isLoggedIn ? (
        registrationId || isStatusPending() ? (
          <Navigate to='/notary/registration' />
        ) : (
          <Navigate to={redirectUrl()} />
        )
      ) : (
        children
      )}
    </>
  );
};

export default PublicRoute;
